import { render, staticRenderFns } from "./admin-layout.vue?vue&type=template&id=d9241b98&scoped=true&"
import script from "./admin-layout.ts?vue&type=script&lang=ts&"
export * from "./admin-layout.ts?vue&type=script&lang=ts&"
import style0 from "./admin-layout.scss?vue&type=style&index=0&id=d9241b98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9241b98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
